import { toString, Union } from "./fable_modules/fable-library-js.4.29.0/Types.js";
import { union_type } from "./fable_modules/fable-library-js.4.29.0/Reflection.js";
import { toArray, tail, head, isEmpty, ofArray, singleton } from "./fable_modules/fable-library-js.4.29.0/List.js";
import { createElement } from "react";
import React from "react";
import { ThemeType, ContextMsg, useCtx } from "./Context.jsx";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useFeliz_React__React_useResponsive_Static_Z434A9929 } from "./fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { useEffectWithDeps } from "./fable_modules/Feliz.2.9.0/ReactInterop.js";
import { createDisposable } from "./fable_modules/Feliz.2.9.0/Internal.fs.js";
import { Caption2, NavDivider, Badge, Text as Text$, NavSubItem, NavSubItemGroup, NavCategoryItem, NavCategory, NavItem, Divider, Image, NavDrawerBody, tokens, NavDrawer } from "@fluentui/react-components";
import { int32ToString, equals, createObj } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { empty, singleton as singleton_1, append, delay, toList } from "./fable_modules/fable-library-js.4.29.0/Seq.js";
import { RouterModule_nav, RouterModule_encodeParts } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { SignOutRegular, SignOutFilled, SettingsRegular, SettingsFilled, DocumentTextRegular, DocumentTextFilled, LayerDiagonalPersonRegular, LayerDiagonalPersonFilled, BookOpenRegular, BookOpenFilled, CalendarLtrRegular, CalendarLtrFilled, bundleIcon, HomeRegular, HomeFilled } from "@fluentui/react-icons";
import { BundleIcons } from "./fable_modules/FS.FluentUI.3.0.0/Utils.fs.js";
import { defaultArgWith, map, defaultArg } from "./fable_modules/fable-library-js.4.29.0/Option.js";
import { formatRegionsRoute } from "./QueryParameters.jsx";
import { Role } from "./Shared/SharedModels.jsx";
import { reactApi as reactApi_1 } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";

export class Tabs extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Home", "Calendar", "Events", "Tracks", "Documentation", "ApproveUsers", "CourseTemplates", "Workplaces", "Regions", "Titles", "Reports", "Rules"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "Kalender" : ((this$.tag === 2) ? "Arrangementer" : ((this$.tag === 3) ? "Min opplæring" : ((this$.tag === 4) ? "Opplæringsplan" : ((this$.tag === 5) ? "Administrer brukere" : ((this$.tag === 6) ? "Kurs" : ((this$.tag === 7) ? "Arbeidsplasser" : ((this$.tag === 8) ? "Regioner" : ((this$.tag === 9) ? "Titler" : ((this$.tag === 10) ? "Rapporter" : ((this$.tag === 11) ? "Automatisering" : "Hjem"))))))))));
    }
}

export function Tabs_$reflection() {
    return union_type("Sidebar.Tabs", [], Tabs, () => [[], [], [], [], [], [], [], [], [], [], [], []]);
}

export function Tabs__ToUrl(this$) {
    switch (this$.tag) {
        case 1:
            return singleton("kalender");
        case 2:
            return singleton("arrangement");
        case 3:
            return singleton("laeringslop");
        case 4:
            return singleton("dokumentasjon");
        case 5:
            return ofArray(["admin", "bruker", "godkjenn"]);
        case 6:
            return ofArray(["laeringslop", "bygger", "kurs"]);
        case 7:
            return ofArray(["admin", "arbeidsplasser"]);
        case 8:
            return ofArray(["admin", "regioner"]);
        case 9:
            return ofArray(["admin", "titler"]);
        case 10:
            return ofArray(["admin", "rapporter"]);
        case 11:
            return ofArray(["admin", "regler"]);
        default:
            return singleton("");
    }
}

export function Tabs_FromUrl_7F866359(url) {
    let matchResult, _rest, _rest_1, _rest_2, _rest_3;
    if (!isEmpty(url)) {
        switch (head(url)) {
            case "admin": {
                if (!isEmpty(tail(url))) {
                    switch (head(tail(url))) {
                        case "bruker": {
                            if (!isEmpty(tail(tail(url)))) {
                                if (head(tail(tail(url))) === "godkjenn") {
                                    if (isEmpty(tail(tail(tail(url))))) {
                                        matchResult = 0;
                                    }
                                    else {
                                        matchResult = 11;
                                    }
                                }
                                else {
                                    matchResult = 11;
                                }
                            }
                            else {
                                matchResult = 11;
                            }
                            break;
                        }
                        case "arbeidsplasser": {
                            if (isEmpty(tail(tail(url)))) {
                                matchResult = 1;
                            }
                            else {
                                matchResult = 11;
                            }
                            break;
                        }
                        case "regioner": {
                            if (isEmpty(tail(tail(url)))) {
                                matchResult = 3;
                            }
                            else {
                                matchResult = 11;
                            }
                            break;
                        }
                        case "titler": {
                            if (isEmpty(tail(tail(url)))) {
                                matchResult = 4;
                            }
                            else {
                                matchResult = 11;
                            }
                            break;
                        }
                        case "rapporter": {
                            if (isEmpty(tail(tail(url)))) {
                                matchResult = 5;
                            }
                            else {
                                matchResult = 11;
                            }
                            break;
                        }
                        case "regler": {
                            if (isEmpty(tail(tail(url)))) {
                                matchResult = 6;
                            }
                            else {
                                matchResult = 11;
                            }
                            break;
                        }
                        default:
                            matchResult = 11;
                    }
                }
                else {
                    matchResult = 11;
                }
                break;
            }
            case "laeringslop": {
                if (!isEmpty(tail(url))) {
                    if (head(tail(url)) === "bygger") {
                        if (!isEmpty(tail(tail(url)))) {
                            if (head(tail(tail(url))) === "kurs") {
                                if (isEmpty(tail(tail(tail(url))))) {
                                    matchResult = 2;
                                }
                                else {
                                    matchResult = 9;
                                    _rest_2 = tail(url);
                                }
                            }
                            else {
                                matchResult = 9;
                                _rest_2 = tail(url);
                            }
                        }
                        else {
                            matchResult = 9;
                            _rest_2 = tail(url);
                        }
                    }
                    else {
                        matchResult = 9;
                        _rest_2 = tail(url);
                    }
                }
                else {
                    matchResult = 9;
                    _rest_2 = tail(url);
                }
                break;
            }
            case "kalender": {
                matchResult = 7;
                _rest = tail(url);
                break;
            }
            case "arrangement": {
                matchResult = 8;
                _rest_1 = tail(url);
                break;
            }
            case "dokumentasjon": {
                matchResult = 10;
                _rest_3 = tail(url);
                break;
            }
            case "": {
                if (isEmpty(tail(url))) {
                    matchResult = 11;
                }
                else {
                    matchResult = 11;
                }
                break;
            }
            default:
                matchResult = 11;
        }
    }
    else {
        matchResult = 11;
    }
    switch (matchResult) {
        case 0:
            return new Tabs(5, []);
        case 1:
            return new Tabs(7, []);
        case 2:
            return new Tabs(6, []);
        case 3:
            return new Tabs(8, []);
        case 4:
            return new Tabs(9, []);
        case 5:
            return new Tabs(10, []);
        case 6:
            return new Tabs(11, []);
        case 7:
            return new Tabs(1, []);
        case 8:
            return new Tabs(2, []);
        case 9:
            return new Tabs(3, []);
        case 10:
            return new Tabs(4, []);
        default:
            return new Tabs(0, []);
    }
}

export function Sidebar(sidebarInputProps) {
    const currentUrl = sidebarInputProps.currentUrl;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    const navBarRef = reactApi.useRef(undefined);
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    let patternInput_1;
    const initial = Tabs_FromUrl_7F866359(currentUrl);
    patternInput_1 = reactApi.useState(initial);
    const setSelectedTab = patternInput_1[1];
    const dependencies = [currentUrl];
    reactApi.useEffect(() => {
        setSelectedTab(Tabs_FromUrl_7F866359(currentUrl));
    }, dependencies);
    useEffectWithDeps(() => {
        if (ctx.NavbarOpen) {
            const handler = (ev) => {
                let el;
                const matchValue = navBarRef.current;
                let matchResult, el_1;
                if (matchValue != null) {
                    if ((el = matchValue, !el.contains(ev.target))) {
                        matchResult = 0;
                        el_1 = matchValue;
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0: {
                        setCtx(new ContextMsg(3, [false]));
                        break;
                    }
                    case 1: {
                        break;
                    }
                }
            };
            document.addEventListener("click", handler);
            return createDisposable(() => {
                document.removeEventListener("click", handler);
            });
        }
        else {
            return createDisposable(() => {
            });
        }
    }, [ctx.NavbarOpen]);
    const el_50 = NavDrawer;
    return createElement(el_50, createObj(toList(delay(() => append(singleton_1(["ref", navBarRef]), delay(() => append(singleton_1(["style", {
        height: ("calc(" + "100vh") + ")",
        width: 260,
        backgroundColor: tokens.colorNeutralBackground1,
    }]), delay(() => append(singleton_1(["selectedValue", toString(patternInput_1[0])]), delay(() => append(singleton_1(["onNavItemSelect", (_arg_2, value_1_2) => {
        switch (screenSize.tag) {
            case 0:
            case 1:
            case 2: {
                setCtx(new ContextMsg(3, [false]));
                break;
            }
            default:
                undefined;
        }
    }]), delay(() => append(singleton_1(["open", (screenSize.tag === 0) ? ctx.NavbarOpen : ((screenSize.tag === 1) ? ctx.NavbarOpen : ((screenSize.tag === 2) ? ctx.NavbarOpen : true))]), delay(() => append(singleton_1(["onOpenChange", (_arg_3, value_1_4) => {
        switch (screenSize.tag) {
            case 0:
            case 1:
            case 2: {
                setCtx(new ContextMsg(3, [value_1_4.open]));
                break;
            }
            default:
                undefined;
        }
    }]), delay(() => append(singleton_1(["multiple", false]), delay(() => {
        let matchValue_1;
        return append((matchValue_1 = screenSize, (matchValue_1.tag === 0) ? singleton_1(["type", "overlay"]) : ((matchValue_1.tag === 1) ? singleton_1(["type", "overlay"]) : ((matchValue_1.tag === 2) ? singleton_1(["type", "overlay"]) : singleton_1(["type", "inline"])))), delay(() => append(singleton_1(["size", "large"]), delay(() => {
            let elems_7, el_48, elems_6;
            return singleton_1((elems_7 = [(el_48 = NavDrawerBody, createElement(el_48, createObj(singleton((elems_6 = toList(delay(() => {
                let elems_1, el_2, elems, el_4;
                return append(singleton_1(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    height: 60,
                    width: 100 + "%",
                }], (elems_1 = [(el_2 = Image, createElement(el_2, createObj(toList(delay(() => append(singleton_1(["style", {
                    margin: 0,
                    padding: 0,
                }]), delay(() => append(equals(ctx.ThemeType, new ThemeType(0, [])) ? singleton_1(["src", "/images/logo.png"]) : singleton_1(["src", "/images/logoDark.png"]), delay(() => append(singleton_1(["height", 35]), delay(() => singleton_1(["fit", "contain"])))))))))))), createElement("div", createObj(ofArray([["style", {
                    justifySelf: "flex-end",
                }], (elems = [(el_4 = Divider, createElement(el_4, {
                    appearance: "subtle",
                }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                    let el_6, icons_1, value_1_10, value_2_1;
                    return append(singleton_1((el_6 = NavItem, createElement(el_6, {
                        href: RouterModule_encodeParts(Tabs__ToUrl(new Tabs(0, [])), 1),
                        onClick: (_arg_4) => {
                            setSelectedTab(new Tabs(0, []));
                            RouterModule_nav(ofArray(toArray(Tabs__ToUrl(new Tabs(0, [])))), 1, 1);
                        },
                        icon: (icons_1 = (new BundleIcons((value_1_10 = HomeFilled, value_1_10), (value_2_1 = HomeRegular, value_2_1))), bundleIcon([icons_1.Filled, icons_1.Regular][0], [icons_1.Filled, icons_1.Regular][1])({
                            fontSize: 24,
                        })),
                        value: toString(new Tabs(0, [])),
                        children: toString(new Tabs(0, [])),
                    }))), delay(() => {
                        let el_8, icons_3, value_1_15, value_2_2;
                        return append(singleton_1((el_8 = NavItem, createElement(el_8, {
                            href: RouterModule_encodeParts(Tabs__ToUrl(new Tabs(1, [])), 1),
                            onClick: (_arg_5) => {
                                setSelectedTab(new Tabs(1, []));
                                RouterModule_nav(ofArray(toArray(Tabs__ToUrl(new Tabs(1, [])))), 1, 1);
                            },
                            icon: (icons_3 = (new BundleIcons((value_1_15 = CalendarLtrFilled, value_1_15), (value_2_2 = CalendarLtrRegular, value_2_2))), bundleIcon([icons_3.Filled, icons_3.Regular][0], [icons_3.Filled, icons_3.Regular][1])({
                                fontSize: 24,
                            })),
                            value: toString(new Tabs(1, [])),
                            children: toString(new Tabs(1, [])),
                        }))), delay(() => {
                            let el_10, icons_5, value_1_20, value_2_3;
                            return append(singleton_1((el_10 = NavItem, createElement(el_10, {
                                href: defaultArg(map((workplace) => formatRegionsRoute(new Int32Array([workplace.Region.Id])), ctx.User.Workplace), RouterModule_encodeParts(Tabs__ToUrl(new Tabs(2, [])), 1)),
                                onClick: (_arg_6) => {
                                    setSelectedTab(new Tabs(2, []));
                                    defaultArgWith(map((workplace_1) => {
                                        RouterModule_nav(singleton(formatRegionsRoute(new Int32Array([workplace_1.Region.Id]))), 1, 1);
                                    }, ctx.User.Workplace), () => {
                                        RouterModule_nav(ofArray(toArray(Tabs__ToUrl(new Tabs(2, [])))), 1, 1);
                                    });
                                },
                                icon: (icons_5 = (new BundleIcons((value_1_20 = BookOpenFilled, value_1_20), (value_2_3 = BookOpenRegular, value_2_3))), bundleIcon([icons_5.Filled, icons_5.Regular][0], [icons_5.Filled, icons_5.Regular][1])({
                                    fontSize: 24,
                                })),
                                value: toString(new Tabs(2, [])),
                                children: toString(new Tabs(2, [])),
                            }))), delay(() => {
                                let el_12, icons_7, value_1_25, value_2_4;
                                return append(singleton_1((el_12 = NavItem, createElement(el_12, {
                                    href: RouterModule_encodeParts(Tabs__ToUrl(new Tabs(3, [])), 1),
                                    onClick: (_arg_7) => {
                                        setSelectedTab(new Tabs(3, []));
                                        RouterModule_nav(ofArray(toArray(Tabs__ToUrl(new Tabs(3, [])))), 1, 1);
                                    },
                                    icon: (icons_7 = (new BundleIcons((value_1_25 = LayerDiagonalPersonFilled, value_1_25), (value_2_4 = LayerDiagonalPersonRegular, value_2_4))), bundleIcon([icons_7.Filled, icons_7.Regular][0], [icons_7.Filled, icons_7.Regular][1])({
                                        fontSize: 24,
                                    })),
                                    value: toString(new Tabs(3, [])),
                                    children: toString(new Tabs(3, [])),
                                }))), delay(() => {
                                    let el_14, icons_9, value_1_30, value_2_5;
                                    return append(singleton_1((el_14 = NavItem, createElement(el_14, {
                                        href: RouterModule_encodeParts(Tabs__ToUrl(new Tabs(4, [])), 1),
                                        onClick: (_arg_8) => {
                                            setSelectedTab(new Tabs(4, []));
                                            RouterModule_nav(ofArray(toArray(Tabs__ToUrl(new Tabs(4, [])))), 1, 1);
                                        },
                                        icon: (icons_9 = (new BundleIcons((value_1_30 = DocumentTextFilled, value_1_30), (value_2_5 = DocumentTextRegular, value_2_5))), bundleIcon([icons_9.Filled, icons_9.Regular][0], [icons_9.Filled, icons_9.Regular][1])({
                                            fontSize: 24,
                                        })),
                                        value: toString(new Tabs(4, [])),
                                        children: toString(new Tabs(4, [])),
                                    }))), delay(() => {
                                        let el_40, elems_5, el_16, icons_11, value_1_35, value_2_6, el_38, elems_4, el_24, elems_3, elems_2, el_26, el_28, el_30, el_32, el_34, el_36;
                                        return append(equals(ctx.User.Role, new Role(1, [])) ? singleton_1((el_40 = NavCategory, createElement(el_40, createObj(ofArray([["value", "Admin"], (elems_5 = [(el_16 = NavCategoryItem, createElement(el_16, {
                                            icon: (icons_11 = (new BundleIcons((value_1_35 = SettingsFilled, value_1_35), (value_2_6 = SettingsRegular, value_2_6))), bundleIcon([icons_11.Filled, icons_11.Regular][0], [icons_11.Filled, icons_11.Regular][1])({
                                                fontSize: 24,
                                            })),
                                            value: "Admin",
                                            children: "Admin",
                                        })), (el_38 = NavSubItemGroup, createElement(el_38, createObj(singleton((elems_4 = [(el_24 = NavSubItem, createElement(el_24, createObj(ofArray([["href", RouterModule_encodeParts(Tabs__ToUrl(new Tabs(5, [])), 1)], ["onClick", (_arg_9) => {
                                            setSelectedTab(new Tabs(5, []));
                                            RouterModule_nav(ofArray(toArray(Tabs__ToUrl(new Tabs(5, [])))), 1, 1);
                                        }], ["value", toString(new Tabs(5, []))], (elems_3 = [createElement("div", createObj(ofArray([["style", {
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 8 + "px ",
                                            width: 100 + "%",
                                            justifyContent: "space-between",
                                        }], (elems_2 = toList(delay(() => {
                                            let el_18;
                                            return append(singleton_1((el_18 = Text$, createElement(el_18, {
                                                children: toString(new Tabs(5, [])),
                                            }))), delay(() => {
                                                let el_22, el_20;
                                                return (ctx.PendingApprovalCount > 0) ? singleton_1((el_22 = Badge, createElement(el_22, {
                                                    size: "small",
                                                    appearance: "filled",
                                                    shape: "rounded",
                                                    children: (el_20 = Text$, createElement(el_20, {
                                                        children: int32ToString(ctx.PendingApprovalCount),
                                                    })),
                                                }))) : empty();
                                            }));
                                        })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])])))), (el_26 = NavSubItem, createElement(el_26, {
                                            href: RouterModule_encodeParts(Tabs__ToUrl(new Tabs(7, [])), 1),
                                            onClick: (_arg_10) => {
                                                setSelectedTab(new Tabs(7, []));
                                                RouterModule_nav(ofArray(toArray(Tabs__ToUrl(new Tabs(7, [])))), 1, 1);
                                            },
                                            value: toString(new Tabs(7, [])),
                                            children: toString(new Tabs(7, [])),
                                        })), (el_28 = NavSubItem, createElement(el_28, {
                                            href: RouterModule_encodeParts(Tabs__ToUrl(new Tabs(11, [])), 1),
                                            onClick: (_arg_11) => {
                                                setSelectedTab(new Tabs(11, []));
                                                RouterModule_nav(ofArray(toArray(Tabs__ToUrl(new Tabs(11, [])))), 1, 1);
                                            },
                                            value: toString(new Tabs(11, [])),
                                            children: toString(new Tabs(11, [])),
                                        })), (el_30 = NavSubItem, createElement(el_30, {
                                            href: RouterModule_encodeParts(Tabs__ToUrl(new Tabs(6, [])), 1),
                                            onClick: (_arg_12) => {
                                                setSelectedTab(new Tabs(6, []));
                                                RouterModule_nav(ofArray(toArray(Tabs__ToUrl(new Tabs(6, [])))), 1, 1);
                                            },
                                            value: toString(new Tabs(6, [])),
                                            children: toString(new Tabs(6, [])),
                                        })), (el_32 = NavSubItem, createElement(el_32, {
                                            href: RouterModule_encodeParts(Tabs__ToUrl(new Tabs(10, [])), 1),
                                            onClick: (_arg_13) => {
                                                setSelectedTab(new Tabs(10, []));
                                                RouterModule_nav(ofArray(toArray(Tabs__ToUrl(new Tabs(10, [])))), 1, 1);
                                            },
                                            value: toString(new Tabs(10, [])),
                                            children: toString(new Tabs(10, [])),
                                        })), (el_34 = NavSubItem, createElement(el_34, {
                                            href: RouterModule_encodeParts(Tabs__ToUrl(new Tabs(8, [])), 1),
                                            onClick: (_arg_14) => {
                                                setSelectedTab(new Tabs(8, []));
                                                RouterModule_nav(ofArray(toArray(Tabs__ToUrl(new Tabs(8, [])))), 1, 1);
                                            },
                                            value: toString(new Tabs(8, [])),
                                            children: toString(new Tabs(8, [])),
                                        })), (el_36 = NavSubItem, createElement(el_36, {
                                            href: RouterModule_encodeParts(Tabs__ToUrl(new Tabs(9, [])), 1),
                                            onClick: (_arg_15) => {
                                                setSelectedTab(new Tabs(9, []));
                                                RouterModule_nav(ofArray(toArray(Tabs__ToUrl(new Tabs(9, [])))), 1, 1);
                                            },
                                            value: toString(new Tabs(9, [])),
                                            children: toString(new Tabs(9, [])),
                                        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])))))], ["children", reactApi_1.Children.toArray(Array.from(elems_5))])]))))) : empty(), delay(() => append(singleton_1(createElement("div", {
                                            style: {
                                                flexGrow: 3,
                                            },
                                        })), delay(() => {
                                            let el_42;
                                            return append(singleton_1((el_42 = NavDivider, createElement(el_42, {}))), delay(() => {
                                                let el_44, icons_13, value_1_61, value_2_7;
                                                return append(singleton_1((el_44 = NavItem, createElement(el_44, {
                                                    href: "/api/logout",
                                                    icon: (icons_13 = (new BundleIcons((value_1_61 = SignOutFilled, value_1_61), (value_2_7 = SignOutRegular, value_2_7))), bundleIcon([icons_13.Filled, icons_13.Regular][0], [icons_13.Filled, icons_13.Regular][1])({
                                                        fontSize: 24,
                                                    })),
                                                    children: "Logg ut",
                                                }))), delay(() => {
                                                    let el_46, matchValue_2;
                                                    return singleton_1((el_46 = Caption2, createElement(el_46, {
                                                        style: {
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            marginBottom: 15,
                                                            color: tokens.colorNeutralForeground3,
                                                        },
                                                        align: "center",
                                                        children: (matchValue_2 = ctx.AppVersion, (matchValue_2 != null) ? (`Av Serit Tromsø - ${matchValue_2}`) : "Av Serit Tromsø"),
                                                    })));
                                                }));
                                            }));
                                        }))));
                                    }));
                                }));
                            }));
                        }));
                    }));
                }));
            })), ["children", reactApi_1.Children.toArray(Array.from(elems_6))])))))], ["children", reactApi_1.Children.toArray(Array.from(elems_7))]));
        }))));
    }))))))))))))))))));
}

//# sourceMappingURL=Sidebar.jsx.map
